import React, { useEffect } from 'react';

const useScrollRestoration = () => {
  useEffect(() => {
    // When the component is mounted, try to restore the scroll position
    const savedPosition = sessionStorage.getItem('scrollPosition');
    if (savedPosition) {
      window.scrollTo(0, savedPosition); // Restore scroll position
    }

    // Add event listener to save scroll position before leaving the page
    const saveScrollPosition = () => {
      sessionStorage.setItem('scrollPosition', window.scrollY); // Save current scroll position
    };

    // Listen to the beforeunload event to save scroll position when navigating away
    window.addEventListener('beforeunload', saveScrollPosition);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', saveScrollPosition);
    };
  }, []);
};

export default useScrollRestoration;
